<template>
  <div class="relative h-full max-h-full w-full max-w-full">
    <Pie
      v-if="Array.isArray(chartData.datasets)"
      :options="chartOptions"
      :data="chartData"
    />
  </div>
</template>

<script>
// https://vue-chartjs.org/examples/
import { Pie } from 'vue-chartjs'

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'

ChartJS.register(ArcElement, Tooltip, Legend)

export default {
  name: 'PieChart',
  components: {
    Pie
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          x: {
            display: false
          }
        }
      }
    }
  }
}
</script>

<style scoped></style>
